export default {"src":"/_next/static/media/ic-twitch-colorized.f98964f6.svg","height":13,"width":12};